import React from "react";
import { Tag, Empty, Spin } from "antd";
import { ClockCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";

const STATUS_COLOR = {
  OPEN: "blue",
  IN_PROGRESS: "orange",
  RESOLVED: "green",
  CLOSED: "default",
};

const CATEGORY_LABEL = {
  BOOKING: "Booking",
  POS: "POS",
  ACCOUNTS: "Accounts",
  CHANNEL_MANAGER: "Channel Manager",
  BOOKING_ENGINE: "Booking Engine",
  PAYMENT_GATEWAY: "Payment Gateway",
  OTHERS: "Others",
};

export default function TicketList({ tickets, loading, onSelect }) {
  if (loading) return <div className="flex justify-center p-8"><Spin /></div>;
  if (!tickets?.length) return (
    <div className="p-8"><Empty description="No tickets found" /></div>
  );

  return (
    <div className="divide-y divide-gray-100">
      {tickets.map((t) => (
        <div
          key={t.id}
          className="p-4 hover:bg-neutral-50 cursor-pointer transition-colors"
          onClick={() => onSelect(t.id)}
        >
          <div className="flex items-start justify-between gap-2 mb-1">
            <div className="text-sm font-medium text-neutral-700 leading-snug flex-1">{t.description?.slice(0,100)}</div>
            <Tag color={STATUS_COLOR[t.status]} className="flex-shrink-0 text-xs">{t.status}</Tag>
          </div>
          <div className="text-xs text-neutral-500 mb-2 flex items-center gap-2 flex-wrap">
            <span className="font-mono">{t.ticketNumber}</span>
            <span>·</span>
            <span>{CATEGORY_LABEL[t.category]}</span>
            {t.replies?.length > 0 && (
              <>
                <span>·</span>
                <span>{t.replies.length} {t.replies.length === 1 ? "reply" : "replies"}</span>
              </>
            )}
          </div>
          <div className="flex items-center justify-between text-xs text-neutral-400">
            <span className="flex items-center gap-1">
              <ClockCircleOutlined />
              {new Date(t.createdAt).toLocaleDateString()}
            </span>
            {t.resolvedAt && (
              <span className="flex items-center gap-1 text-success">
                <CheckCircleOutlined />
                Resolved {new Date(t.resolvedAt).toLocaleDateString()}
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
